import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './BirthdayOverlay.css';

// 🎉 Easter Egg: Overlay di compleanno per cristiana (1 ottobre), marco (12 gennaio), filippo (10 aprile)
const BirthdayOverlay = ({ testMode = false }) => {
  const { user } = useAuth();
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [confetti, setConfetti] = useState([]);
  const [fireworks, setFireworks] = useState([]);

  // Controlla se oggi è il compleanno di uno degli utenti
  const checkBirthday = () => {
    const today = new Date();
    const month = today.getMonth() + 1; // Gennaio = 1, Aprile = 4, Ottobre = 10
    const day = today.getDate();
    
    // Definisce gli utenti e le loro date di compleanno
    const birthdays = [
      {
        names: ['cristiana'],
        month: 10,
        day: 1,
        fullName: 'Cristiana'
      },
      {
        names: ['marco'],
        month: 1,
        day: 12,
        fullName: 'Marco'
      },
      {
        names: ['filippo'],
        month: 4,
        day: 10,
        fullName: 'Filippo'
      }
    ];
    
    // Trova l'utente corrente
    const currentUser = user?.username?.toLowerCase() || 
                       user?.UTE_Username?.toLowerCase() ||
                       user?.nome?.toLowerCase() ||
                       user?.UTE_Nome?.toLowerCase();
    
    // Trova se l'utente corrente ha il compleanno oggi
    const birthdayUser = birthdays.find(birthday => 
      birthday.names.includes(currentUser) && 
      (testMode || (birthday.month === month && birthday.day === day))
    );
    
    console.log('🎂 Birthday check:', { 
      user: currentUser, 
      month, 
      day, 
      birthdayUser: birthdayUser?.fullName || null,
      testMode 
    });
    
    return birthdayUser;
  };

  // ✅ NEW: Funzione per scomparsa elegante
  const handleExit = () => {
    setIsExiting(true);
    // Dopo l'animazione di fade-out, nascondi completamente
    setTimeout(() => {
      setIsVisible(false);
      setIsExiting(false);
    }, 800); // Durata dell'animazione fade-out
  };

  // Genera fuochi d'artificio
  const generateFireworks = () => {
    const colors = ['#FF1744', '#FF9800', '#FFEB3B', '#4CAF50', '#2196F3', '#9C27B0'];
    const fireworksArray = [];
    
    for (let i = 0; i < 6; i++) {
      fireworksArray.push({
        id: `firework-${i}`,
        x: Math.random() * window.innerWidth,
        y: Math.random() * (window.innerHeight / 2) + 100,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: i * 0.5
      });
    }
    
    return fireworksArray;
  };

  // Genera particelle di coriandoli
  const generateConfetti = () => {
    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9'];
    const particles = [];
    
    for (let i = 0; i < 50; i++) {
      particles.push({
        id: i,
        x: Math.random() * window.innerWidth,
        y: -10,
        color: colors[Math.floor(Math.random() * colors.length)],
        size: Math.random() * 10 + 5,
        speedX: (Math.random() - 0.5) * 4,
        speedY: Math.random() * 3 + 2,
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 10
      });
    }
    
    return particles;
  };

  // Animazione coriandoli e fuochi d'artificio
  useEffect(() => {
    if (!isVisible) return;

    const confettiParticles = generateConfetti();
    const fireworksArray = generateFireworks();
    setConfetti(confettiParticles);
    setFireworks(fireworksArray);

    const animateConfetti = () => {
      setConfetti(prev => 
        prev.map(particle => ({
          ...particle,
          x: particle.x + particle.speedX,
          y: particle.y + particle.speedY,
          rotation: particle.rotation + particle.rotationSpeed
        })).filter(particle => particle.y < window.innerHeight + 50)
      );
    };

    const interval = setInterval(animateConfetti, 50);
    return () => clearInterval(interval);
  }, [isVisible]);

  // Controlla il compleanno quando il componente monta o cambia l'utente
  useEffect(() => {
    const birthdayUser = checkBirthday();
    if (user && birthdayUser) {
      setIsVisible(true);
      
      // Auto-hide dopo 5 secondi con animazione
      const timer = setTimeout(() => {
        handleExit();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [user]);

  if (!isVisible) return null;

  return (
    <div className={`fixed inset-0 z-[9999] pointer-events-none transition-all duration-800 ${
      isExiting ? 'animate-fade-out' : ''
    }`}>
      {/* Overlay di sfondo */}
      <div className={`absolute inset-0 bg-black/20 backdrop-blur-sm transition-all duration-800 ${
        isExiting ? 'animate-fade-out' : 'animate-fade-in'
      }`} />
      
      {/* Fuochi d'artificio */}
      {fireworks.map(firework => (
        <div
          key={firework.id}
          className={`firework animate-sparkle transition-opacity duration-800 ${
            isExiting ? 'opacity-0' : ''
          }`}
          style={{
            left: `${firework.x}px`,
            top: `${firework.y}px`,
            backgroundColor: firework.color,
            animationDelay: `${firework.delay}s`,
            boxShadow: `0 0 20px ${firework.color}`
          }}
        />
      ))}
      
      {/* Coriandoli animati */}
      {confetti.map(particle => (
        <div
          key={particle.id}
          className={`absolute w-2 h-2 opacity-80 transition-opacity duration-800 ${
            isExiting ? 'opacity-0' : ''
          }`}
          style={{
            left: `${particle.x}px`,
            top: `${particle.y}px`,
            backgroundColor: particle.color,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            transform: `rotate(${particle.rotation}deg)`,
            borderRadius: Math.random() > 0.5 ? '50%' : '0',
            transition: 'all 0.05s linear, opacity 0.8s ease-in'
          }}
        />
      ))}
      
      {/* Messaggio principale */}
      <div className={`absolute inset-0 flex items-center justify-center transition-all duration-800 ${
        isExiting ? 'animate-slide-up-out' : ''
      }`}>
        <div className={`text-center transition-all duration-1000 ${
          isExiting ? 'animate-fade-out transform scale-75' : 'animate-bounce-in'
        }`}>
          {/* Titolo */}
          <h1 className="text-6xl md:text-8xl font-bold bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 bg-clip-text text-transparent mb-4 animate-pulse">
            🎉 BUON COMPLEANNO! 🎂
          </h1>
          
          {/* Sottotitolo */}
          <p className="text-2xl md:text-4xl font-semibold text-white mb-6 drop-shadow-lg">
            Auguri {(() => {
              const birthdayUser = checkBirthday();
              return birthdayUser?.fullName || user?.nome || user?.UTE_Nome || 'amico';
            })()} ! 🎈
          </p>
          
          {/* Emoji animate */}
          <div className="flex justify-center space-x-4 text-4xl md:text-6xl">
            <span className="animate-bounce delay-100">🎊</span>
            <span className="animate-bounce delay-200">🎁</span>
            <span className="animate-bounce delay-300">🍰</span>
            <span className="animate-bounce delay-400">🎉</span>
            <span className="animate-bounce delay-500">🎈</span>
          </div>
          
          {/* Fireworks effect */}
          <div className="absolute top-10 left-10 animate-ping">
            <div className="w-8 h-8 bg-yellow-400 rounded-full opacity-75"></div>
          </div>
          <div className="absolute top-20 right-20 animate-ping delay-500">
            <div className="w-6 h-6 bg-red-400 rounded-full opacity-75"></div>
          </div>
          <div className="absolute bottom-20 left-20 animate-ping delay-1000">
            <div className="w-10 h-10 bg-blue-400 rounded-full opacity-75"></div>
          </div>
          <div className="absolute bottom-10 right-10 animate-ping delay-700">
            <div className="w-7 h-7 bg-green-400 rounded-full opacity-75"></div>
          </div>
        </div>
      </div>
      
      {/* Bottone per chiudere manualmente (opzionale) */}
      <button
        onClick={handleExit}
        className="absolute top-4 right-4 bg-white/20 hover:bg-white/30 text-white rounded-full p-2 backdrop-blur-sm transition-all duration-200 pointer-events-auto"
        title="Chiudi"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default BirthdayOverlay;